import { WidgetType, type Widget } from 'features/chat/agent-chat-module/types/agent.service.type';
import type {
  ChatbotWidget,
  ChatbotWidgetDesignSettings,
  WidgetBannerSettings,
} from './index.type';

const defaultDesignSettings: ChatbotWidgetDesignSettings & WidgetBannerSettings = {
  headerStartColor: '#000000',
  headerEndColor: '#000000',
  titleColor: '#FFFFFF',
  chatBackgroundColor: '#FFFFFF',
  chatFontColor: '#000000',
  sendButtonBackgroundColor: '#000000',
  sendButtonFontColor: '#FFFFFF',
  borderColor: '#E2E8F0',
  'chat-toggle-button--background-color': '#000000',
  'chat-toggle-button--color': '#FFFFFF',
  banner: {
    enabled: false,
    imageUrl: '',
    imageId: '',
    text: '',
  },
};

export const defaultChatbotWidget: ChatbotWidget = {
  name: '',
  logo_url: '',
  logo_id: null,
  fe_script: null,
  show_agent_name: true,
  greeting: '',
  site_url: null,
  brand_color: null,
  predefined_questions: [],
  enable_predefined_questions: true,
  designSettings: defaultDesignSettings,
};

const parseWidgetDesignSettings = (widget: Widget) => {
  const chatSettings = widget.widget_settings.find((item) => item.widget_type === WidgetType.CHAT);

  if (!chatSettings?.fe_style) {
    return defaultDesignSettings;
  }

  try {
    return { ...defaultDesignSettings, ...JSON.parse(chatSettings.fe_style) };
  } catch {
    return defaultDesignSettings;
  }
};

export const parseChatbotWidgetData = (widget?: Widget): ChatbotWidget => {
  if (!widget) {
    return defaultChatbotWidget;
  }

  return {
    ...widget,
    designSettings: parseWidgetDesignSettings(widget),
  };
};

export const formatLastSavedLabel = (value?: string | Date | null) => {
  if (!value) return 'Never';

  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return 'Never';

  return date.toLocaleString([], {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};
